export const blockBoardPanningAttr = 'data-block-board-panning';
